import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Row, Col } from 'react-bootstrap';
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaRegCreditCard,
  FaReceipt,
  FaMoneyCheckAlt,
  FaMoneyBill,
  FaBarcode,
  FaTimesCircle,
} from 'react-icons/fa';
import numeral from 'numeral';
import { Timeline, TimelineItem } from 'vertical-timeline-component-for-react';
import { toast } from 'react-toastify';

import * as helpers from '~/Utils/Helpers';
import * as api from '../Services/Service';
import CardDocumento from '../Components/Prospectos/ProspectoDetalhes/CamposDocumentos/CardDocumento';
import {
  DESCRICOES_STATUS_COMPROVANTE,
  TIPO_UPLOAD_PDF,
  TIPO_TITULO,
  TIPO_HISTORICO_PROPOSTA_RAPIDA,
  TIPO_HISTORICO_PROPOSTA_RAPIDA_CORES,
} from '../constant';
import buildPDFFromImage from '../Utils/ImageToPdf';
import { MOTIVOS_RECUSA_DOCUMENTOS } from '../Components/Comercial/Comprovantes/Motivos';
import { format } from '../Utils/Helpers';
import PDFThumb from '~/Utils/PDFThumb';
import { DATETIME_DEFAULT_FORMAT } from '~/constant';
import {
  ePagamentoExclusivamenteDinheiro,
  permiteValidacaoComprovante,
} from './AnexarComprovantePolicy';

//TODO: um lugar melhor para colocar isso?
numeral.register('locale', 'br', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  currency: {
    symbol: 'R$',
  },
});

// switch between locales
numeral.locale('br');

const getCorStatusComprovante = status => {
  const statusComprovante = DESCRICOES_STATUS_COMPROVANTE.find(
    item => item.value === status
  );

  return statusComprovante ? statusComprovante.cor : null;
};

const statusPorTipoHistorico = {
  [TIPO_HISTORICO_PROPOSTA_RAPIDA.INCLUSAO_DOCUMENTO]: 2,
  [TIPO_HISTORICO_PROPOSTA_RAPIDA.APROVACAO]: 3,
  [TIPO_HISTORICO_PROPOSTA_RAPIDA.RECUSA]: 9,
  [TIPO_HISTORICO_PROPOSTA_RAPIDA.RECEBIMENTO_APROVADO]: 3,
  [TIPO_HISTORICO_PROPOSTA_RAPIDA.BAIXA_CONFIRMADA]: 4,
};

const getCorHistoricoComprovante = (tipo, historicoAtual, statusAtual) => {
  if (historicoAtual && statusAtual) {
    return statusAtual.cor;
  }

  const corStatus = getCorStatusComprovante(statusPorTipoHistorico[tipo]);
  if (corStatus) {
    return corStatus;
  }

  const tipoHistorico = TIPO_HISTORICO_PROPOSTA_RAPIDA_CORES.find(
    item => item.value === tipo
  );

  return tipoHistorico ? tipoHistorico.color : '#6c757d';
};

class AnexarComprovante extends Component {
  state = {
    documentoModal: null,
    documentos: [],
    carregandoDocumentos: false,
    carregandoTitulos: false,
    carregandoDadosBancarios: false,
    carregandoHistorico: false,
    exibePainelCancelamento: false,
    motivosSelecionados: [],
    status_documentacao: null,
    caracteristica: null,
    dados_bancarios: [],
    observacoes: [],
    titulos: [],
    justificativa: '',
    historico: [],
    exibirConfirmacaoPendencia: false,
    exibeModalJustificativa: false,
    acaoJustificativa: null,
  };

  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        prevenda: PropTypes.string.isRequired,
        ge: PropTypes.string.isRequired,
        empreendimento: PropTypes.object,

        // ajuste para funcionar na adm vendas v1, remover depois
        qd: PropTypes.string,
        lt: PropTypes.string,
        familia: PropTypes.string,
      }),
    }),
  };

  buildDocumento = async documento => ({
    sequencia: documento.sequencia,
    url: documento.url,
    Thumb:
      documento.titulo && !documento.url.includes('hml')
        ? await PDFThumb.create(documento.url)
        : null,
    descricao: (
      <>
        {documento.titulo}
        <small className="d-block mt-2">
          Digitalizado por:{' '}
          <span className="font-weight-bold">{documento.usuario}</span>
        </small>
      </>
    ),
  });

  async componentDidMount() {
    this.setState({
      carregandoDocumentos: true,
      carregandoTitulos: true,
      carregandoDadosBancarios: true,
      carregandoHistorico: true,
    });
    const { prevenda, ge } = this.props.match.params;
    const {
      arquivos_pre_venda,
      caracteristica,
    } = await api.consultarComprovantes(prevenda, ge);

    let { dados_bancarios } = await api.obterDadosBancariosPreVenda(prevenda);
    const { titulos } = await api.buscarTitulosSinalPreVenda(prevenda);
    const historico = await api.buscarHistoricoDocumentacao(prevenda);
    const { arquivos, status_documentacao } = arquivos_pre_venda;

    dados_bancarios = dados_bancarios || [];

    if (
      this.props.match.params.empreendimento === null ||
      this.props.match.params.empreendimento === undefined
    ) {
      this.props.match.params.empreendimento = {
        nome: this.props.match.params.familia,
        quadra: this.props.match.params.qd,
        lote: this.props.match.params.lt,
      };
    }

    this.setState({
      status_documentacao,
      caracteristica,
      titulos,
      dados_bancarios,
      historico,
      carregandoTitulos: false,
      carregandoDadosBancarios: false,
      carregandoHistorico: false,
    });

    Promise.all(
      arquivos.map(async item => await this.buildDocumento(item))
    ).then(documentos => {
      this.setState({
        documentos,
        carregandoDocumentos: false,
      });
    });
  }

  setDocumentoModal = documento => {
    this.setState({
      documentoModal: documento,
    });
  };

  getStatusAprovacao = () => {
    const { caracteristica, status_documentacao } = this.state;
    const statusNumerico = parseInt(status_documentacao, 10);
    const isWebSecVendas = caracteristica === 'WebSecVendas';
    const isWebAprovaComprov = caracteristica === 'WebAprovaComprov';
    const isWebFinanceiro = caracteristica === 'WebFinanceiro';

    if (isWebSecVendas || isWebAprovaComprov || isWebFinanceiro) {
      return statusNumerico === 3 && (isWebAprovaComprov || isWebFinanceiro)
        ? '4'
        : '3';
    }

    return '4';
  };

  getStatusRecusa = () => {
    const { caracteristica, status_documentacao } = this.state;
    const statusNumerico = parseInt(status_documentacao, 10);
    const isWebSecVendas = caracteristica === 'WebSecVendas';
    const isWebAprovaComprov = caracteristica === 'WebAprovaComprov';
    const isWebFinanceiro = caracteristica === 'WebFinanceiro';

    if (isWebSecVendas || isWebAprovaComprov || isWebFinanceiro) {
      return statusNumerico === 3 && (isWebAprovaComprov || isWebFinanceiro)
        ? '8'
        : '9';
    }

    return '8';
  };

  abrirModalJustificativa = acaoJustificativa => {
    this.setState({
      acaoJustificativa,
      exibeModalJustificativa: true,
      exibirConfirmacaoPendencia: acaoJustificativa === 'pendencia',
      justificativa: '',
    });
  };

  fecharModalJustificativa = () => {
    this.setState({
      acaoJustificativa: null,
      exibeModalJustificativa: false,
      exibirConfirmacaoPendencia: false,
      justificativa: '',
    });
  };

  confirmarModalJustificativa = () => {
    const { acaoJustificativa } = this.state;
    const novoStatus =
      acaoJustificativa === 'pendencia' ? '10' : this.getStatusAprovacao();

    this.atualizarStatusComprovante(novoStatus);
  };

  inputRef = React.createRef();

  uploadComprovante = async acceptedFiles => {
    let request = new FormData();
    const { prevenda, ge } = this.props.match.params;

    let pdf = null;
    if (acceptedFiles.type === TIPO_UPLOAD_PDF) pdf = acceptedFiles;
    else pdf = await buildPDFFromImage(acceptedFiles);

    request.append('Arquivo', pdf);

    const {
      status_documentacao,
      arquivo,
      historico,
    } = await api.uploadComprovante(request, ge, prevenda);
    const doc = await this.buildDocumento(arquivo);
    this.setState({
      documentos: [...this.state.documentos, doc],
      status_documentacao,
      historico,
    });

    //Limpar input do upload
    this.inputRef.current.value = '';
  };

  onRemove = async documento => {
    const { status_documentacao, historico } = await api.removerComprovante(
      documento.sequencia
    );
    if (status_documentacao) {
      //verificar se foi sucesso e executar:
      const documentos = this.state.documentos.filter(item => {
        return item.sequencia !== documento.sequencia;
      });
      this.setState({ documentos, status_documentacao, historico });
    } else {
      //tratar erro
    }
  };

  atualizarStatusComprovante = async status => {
    const { prevenda } = this.props.match.params;
    const { observacoes, motivosSelecionados, justificativa } = this.state;
    if (!justificativa) {
      toast.warning(
        `Informe uma justificativa para a ${
          this.state.exibirConfirmacaoPendencia ? 'pendência' : 'aprovação'
        }!`
      );
      return;
    }

    let novo_status = status;

    let motivos = motivosSelecionados.filter(item => !item.includes('Sub'));

    const request = {
      novo_status,
      pre_venda: prevenda,
      motivos,
      observacoes,
      justificativa,
    };
    try {
      let response = await api.atualizarStatusComprovante(request);
      const { status_documentacao, historico } = response;
      toast.success('Status da documentação alterado com sucesso');
      this.setState({
        status_documentacao,
        historico,
        exibePainelCancelamento: false,
        exibeModalJustificativa: false,
        acaoJustificativa: null,
        exibirConfirmacaoPendencia: false,
        justificativa: '',
      });
    } catch (err) {
      toast.error(err.message || 'Erro ao alterar status da documentação ');
    }
  };

  exibirPainelCancelamento = exibePainelCancelamento => {
    this.setState({
      exibePainelCancelamento,
      motivosSelecionados: [],
      observacoes: [],
      justificativa: '',
      exibirConfirmacaoPendencia: false,
    });
  };

  alterarMotivo = event => {
    let motivosSelecionados = this.state.motivosSelecionados;
    const id = event.target.value;

    if (event.target.checked) {
      motivosSelecionados.push(id);
    } else {
      motivosSelecionados = motivosSelecionados.filter(item => {
        return item !== id;
      });
    }

    this.setState({ motivosSelecionados });
  };

  selecionouUmSubgrupo = Motivos => {
    //filtra motivos selecionados com subgrupos
    const motivosComSubGrupos = MOTIVOS_RECUSA_DOCUMENTOS.filter(
      item =>
        item.subGrupo && this.state.motivosSelecionados.indexOf(item.value) > -1
    );

    //se a lista for vazia retorna true (permitido enviar o formulário)
    if (motivosComSubGrupos.length === 0) return true;

    //retorna um boolean se todos os motivos com subgrupo tem ao menos um item selecionado
    return motivosComSubGrupos.reduce((prev, curr) => {
      return (
        prev &&
        curr.subGrupo.reduce((prev, curr) => {
          return (
            prev || this.state.motivosSelecionados.indexOf(curr.value) > -1
          );
        }, false)
      );
    }, true);
  };

  setObservacoes = (motivo, Observacao) => {
    let ObservacoesAtual = this.state.observacoes;
    let key = `${motivo.label}:`;

    var observacoes = ObservacoesAtual.filter(item => !item.includes(key));
    observacoes.push(`${key} ${Observacao}`);
    this.setState({
      observacoes,
    });
  };

  habilitarUpload = () => {
    const { titulos } = this.state;

    return (
      titulos.length > 0 &&
      !ePagamentoExclusivamenteDinheiro(titulos, TIPO_TITULO.DINHEIRO)
    );
  };

  render() {
    const {
      documentoModal,
      documentos,
      exibePainelCancelamento,
      motivosSelecionados,
      status_documentacao,
      caracteristica,
      titulos,
      dados_bancarios,
      historico,
      carregandoDocumentos,
      carregandoTitulos,
      carregandoDadosBancarios,
      carregandoHistorico,
      justificativa,
      exibeModalJustificativa,
      acaoJustificativa,
    } = this.state;
    const habilitarUploadDelete =
      (status_documentacao === 0 ||
        status_documentacao === 1 ||
        status_documentacao === 2 ||
        status_documentacao === 8 ||
        status_documentacao === 9) &&
      caracteristica !== 'WebFinanceiro';
    const StatusAtual = DESCRICOES_STATUS_COMPROVANTE.find(
      item => item.value === parseInt(status_documentacao, 10)
    );
    const statusNumerico = parseInt(status_documentacao, 10);
    const exibeAcaoPendente = statusNumerico === 3;
    const permiteValidacao = permiteValidacaoComprovante({
      statusDocumentacao: status_documentacao,
      titulos,
      quantidadeDocumentos: documentos.length,
      tipoDinheiro: TIPO_TITULO.DINHEIRO,
    });

    const exibeBotoesAprovacao =
      permiteValidacao &&
      (((status_documentacao == 2 ||
        status_documentacao == 3 ||
        status_documentacao == 10 ||
        status_documentacao == 0) &&
        caracteristica == 'WebAprovaComprov') ||
        ((status_documentacao == 2 ||
          (status_documentacao == 0 && caracteristica === 'WebSecVendas') ||
          status_documentacao == 3 ||
          status_documentacao == 10 ||
          (status_documentacao == 0 && caracteristica === 'WebFinanceiro')) &&
          caracteristica != 'Corretor'));

    const desabilitarBotaoRecusar =
      motivosSelecionados.length === 0 ||
      !this.selecionouUmSubgrupo(MOTIVOS_RECUSA_DOCUMENTOS) ||
      justificativa.length === 0;

    const desabilitarBotaoAprovar = justificativa.length === 0;
    const tituloModalJustificativa =
      acaoJustificativa === 'pendencia'
        ? 'Registrar pendência'
        : 'Aprovar comprovante';
    const descricaoModalJustificativa =
      acaoJustificativa === 'pendencia'
        ? 'Informe a justificativa para retornar a documentação como pendente.'
        : 'Informe a justificativa para aprovar a documentação analisada.';
    const placeholderModalJustificativa =
      acaoJustificativa === 'pendencia'
        ? 'Justificativa de pendência (obrigatória)'
        : 'Justificativa de aprovação (obrigatória)';

    return (
      <>
        <div className="comprovante-page">
          <section className="comprovante-hero">
            <div className="comprovante-hero__actions">
              {StatusAtual && (
                <span
                  className="comprovante-status-pill"
                  style={{ background: StatusAtual.cor }}
                >
                  {StatusAtual.label}
                </span>
              )}
            </div>
          </section>

          <div className="comprovante-info-grid">
            {this.props.match.params.empreendimento && (
              <section className="comprovante-section">
                <h5 className="comprovante-section__title">
                  {this.props.match.params.empreendimento.nome}
                </h5>
                <div className="comprovante-field-grid">
                  <div>
                    <span>Quadra</span>
                    <strong>
                      {this.props.match.params.empreendimento.quadra}
                    </strong>
                  </div>
                  <div>
                    <span>Lote</span>
                    <strong>{this.props.match.params.empreendimento.lote}</strong>
                  </div>
                </div>
              </section>
            )}

            <section className="comprovante-section">
              <h5 className="comprovante-section__title">Títulos de sinal</h5>
              {carregandoTitulos && (
                <p className="text-muted mb-0">Carregando títulos de sinal...</p>
              )}
              {!carregandoTitulos && titulos.length === 0 && (
                <p className="text-muted mb-0">Nenhum título encontrado.</p>
              )}
              {!carregandoTitulos &&
                titulos.map(titulo => {
                  const accent = titulo.baixado ? 'success' : 'dark';
                  const accentMuted = titulo.baixado ? 'success' : 'muted';
                  const tituloKey = [
                    titulo.tipo,
                    titulo.valor,
                    titulo.data_vencimento,
                    titulo.promisoria && titulo.promisoria.NossoNumero,
                  ].join('-');

                  return (
                    <div
                      key={tituloKey}
                      className={`comprovante-titulo comprovante-titulo--${accent}`}
                    >
                      <div className="comprovante-titulo__main">
                        <strong>
                          R$ {numeral(titulo.valor).format('(R$ 0,00.00)')}
                        </strong>
                        <span className={`text-${accentMuted}`}>
                          Vencimento {format.date(titulo.data_vencimento)}
                        </span>
                      </div>
                      <div className="comprovante-titulo__tipo">
                        {titulo.promisoria &&
                          titulo.promisoria.NossoNumero !== 'DEP' && (
                            <small className={`text-${accentMuted}`}>
                              {titulo.promisoria &&
                                titulo.promisoria.NossoNumero}
                            </small>
                          )}
                        {titulo.tipo === TIPO_TITULO.CARTAO && (
                          <span>
                            <FaRegCreditCard />
                            <small>Cartão</small>
                          </span>
                        )}
                        {titulo.tipo === TIPO_TITULO.DEPOSITO && (
                          <span>
                            <FaReceipt />
                            <small>Depósito</small>
                          </span>
                        )}
                        {titulo.tipo === TIPO_TITULO.CHEQUE && (
                          <span>
                            <FaMoneyCheckAlt />
                            <small>Cheque</small>
                          </span>
                        )}
                        {titulo.tipo === TIPO_TITULO.DINHEIRO && (
                          <span>
                            <FaMoneyBill />
                            <small>Dinheiro</small>
                          </span>
                        )}
                        {titulo.tipo === TIPO_TITULO.BOLETO && (
                          <span>
                            <FaBarcode />
                            <small>Boleto</small>
                          </span>
                        )}
                      </div>
                      {titulo.tipo === TIPO_TITULO.CHEQUE && (
                        <div className="comprovante-cheque-grid">
                          <span>Banco {titulo.cheque.banco}</span>
                          <span>Agência {titulo.cheque.agencia}</span>
                          <span>Conta {titulo.cheque.conta}</span>
                          <span>Número {titulo.cheque.numero}</span>
                          <span>Emitente {titulo.cheque.emitente}</span>
                          <span>CPF {titulo.cheque.cgccpf}</span>
                        </div>
                      )}
                    </div>
                  );
                })}
            </section>
          </div>

          <section className="comprovante-section">
            <h5 className="comprovante-section__title">Dados bancários</h5>
            {carregandoDadosBancarios && (
              <p className="text-muted mb-0">Carregando dados bancários...</p>
            )}
            {!carregandoDadosBancarios &&
              dados_bancarios.map(b => {
                return (
                  <div
                    className="comprovante-banco"
                    key={`${b.codigo_banco}-${b.agencia}-${b.conta}`}
                  >
                    <div>
                      <span>Banco</span>
                      <strong>
                        {b.codigo_banco} - {b.nome_banco}
                      </strong>
                    </div>
                    <div>
                      <span>Agência</span>
                      <strong>{b.agencia}</strong>
                    </div>
                    <div>
                      <span>Conta</span>
                      <strong>{b.conta}</strong>
                    </div>
                  </div>
                );
              })}
            {!carregandoDadosBancarios && dados_bancarios.length === 0 && (
              <p className="text-muted mb-0">Nenhum registro bancário encontrado.</p>
            )}
          </section>

          <section className="comprovante-section CamposDocumentos">
            <div className="comprovante-section__header">
              <div>
                <h5 className="comprovante-section__title">Documentos</h5>
              </div>
              <div className="comprovante-documentos-actions">
                <span className="comprovante-documentos-count">
                  {documentos.length} arquivo(s)
                </span>
                {habilitarUploadDelete && this.habilitarUpload() && (
                  <label htmlFor="UploadArquivo" className="mb-0">
                    <button
                      className="btn btn-primary comprovante-upload-btn"
                      type="button"
                      onClick={() => {
                        this.inputRef.current.click();
                      }}
                    >
                      Adicionar arquivo
                    </button>
                    <input
                      type="file"
                      className="d-none"
                      name="UploadArquivo"
                      id="UploadArquivo"
                      ref={this.inputRef}
                      onChange={event => {
                        this.uploadComprovante(event.target.files[0]);
                      }}
                    />
                  </label>
                )}
              </div>
            </div>

            {carregandoDocumentos && (
              <p className="text-muted mb-0">Carregando documentos...</p>
            )}
            {!carregandoDocumentos && documentos.length === 0 && (
              <p className="text-muted mb-0">Nenhum documento inserido ainda.</p>
            )}
            {!carregandoDocumentos && (
              <ul className="list-unstyled comprovante-documentos-list">
                {documentos.map(documento => {
                  return (
                    <CardDocumento
                      key={documento.sequencia || documento.url}
                      documento={documento}
                      onRemove={this.onRemove}
                      enableTrash={habilitarUploadDelete}
                      onClickDocumento={this.setDocumentoModal}
                      onSelectImage={() => {}}
                      onThumbCreated={() => {}}
                    />
                  );
                })}
              </ul>
            )}
          </section>

          {exibeBotoesAprovacao && (
            <div className="comprovante-validacao">
              {!exibePainelCancelamento && (
                <div className="comprovante-validacao__acoes">
                  <div>
                    <h5 className="comprovante-section__title mb-0">
                      Validação
                    </h5>
                  </div>
                  <div className="comprovante-validacao__buttons">
                    <button
                      type="button"
                      className="btn btn-success comprovante-validacao__button"
                      onClick={() => this.abrirModalJustificativa('aprovar')}
                    >
                      <FaCheckCircle className="mr-2" />
                      Aprovar
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-danger comprovante-validacao__button"
                      onClick={() => this.exibirPainelCancelamento(true)}
                    >
                      <FaTimesCircle className="mr-2" />
                      Recusar
                    </button>
                    {exibeAcaoPendente && (
                      <button
                        type="button"
                        className="btn btn-outline-warning comprovante-validacao__button"
                        onClick={() =>
                          this.abrirModalJustificativa('pendencia')
                        }
                      >
                        <FaExclamationTriangle className="mr-2" />
                        Pendente
                      </button>
                    )}
                  </div>
                </div>
              )}
              {exibePainelCancelamento && (
                <div className="comprovante-recusa">
                  <Row>
                    <Col>
                      <div>
                        <div className="row form-group mb-3">
                          <div className="col-12">
                            <div className="comprovante-recusa__header">
                              <h5 className="mb-1">
                                Informe os motivos e a justificativa
                              </h5>
                            </div>
                            <table
                              id="motivos"
                              className="table table-condensed table-center"
                            >
                              <tbody>
                                {MOTIVOS_RECUSA_DOCUMENTOS.map(item => (
                                  <tr key={item.value}>
                                    <td>
                                      <div className="d-flex">
                                        <label htmlFor={item.value}>
                                          <input
                                            id={item.value}
                                            type="checkbox"
                                            name="motivo"
                                            value={item.value}
                                            className="teclaenter"
                                            onChange={this.alterarMotivo}
                                          />
                                          {item.label}
                                        </label>
                                      </div>
                                      {motivosSelecionados.indexOf(item.value) >
                                        -1 &&
                                        item.subGrupo && (
                                          <div className="d-flex pl-5">
                                            <table className="w-100">
                                              <tbody>
                                                {item.subGrupo.map(subitem => (
                                                  <tr key={subitem.value}>
                                                    <td>
                                                      <div className="ItemSubGrupo d-flex align-items-center">
                                                        <label
                                                          htmlFor={
                                                            subitem.value
                                                          }
                                                        >
                                                          <input
                                                            id={subitem.value}
                                                            type="checkbox"
                                                            name="motivo"
                                                            value={
                                                              subitem.value
                                                            }
                                                            onChange={
                                                              this.alterarMotivo
                                                            }
                                                          />
                                                          {subitem.label}
                                                        </label>
                                                        {motivosSelecionados.indexOf(
                                                          subitem.value
                                                        ) > -1 &&
                                                          subitem.outros && (
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              placeholder={
                                                                subitem.outros
                                                              }
                                                              onBlur={event =>
                                                                this.setObservacoes(
                                                                  subitem,
                                                                  event.target
                                                                    .value
                                                                )
                                                              }
                                                            />
                                                          )}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                            </table>
                                          </div>
                                        )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <textarea
                              autoFocus
                              className="form-control mx-auto comprovante-recusa__textarea"
                              placeholder="Justificativa (obrigatória)"
                              value={justificativa}
                              onChange={e =>
                                this.setState({ justificativa: e.target.value })
                              }
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="text-center">
                    <Col md={{ span: 2, offset: 4 }} xs={6}>
                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={() => this.exibirPainelCancelamento(false)}
                      >
                        Cancelar
                      </button>
                    </Col>
                    <Col md={2} xs={6}>
                      <button
                        type="button"
                        className="btn btn-danger"
                        disabled={desabilitarBotaoRecusar}
                        onClick={() =>
                          this.atualizarStatusComprovante(
                            this.getStatusRecusa()
                          )
                        }
                      >
                        Recusar
                      </button>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          )}

          <section className="comprovante-section comprovante-historico">
            <div className="comprovante-section__header">
              <div>
                <h5 className="comprovante-section__title">Histórico</h5>
              </div>
            </div>

            {carregandoHistorico && (
              <p className="text-muted mb-0">Carregando histórico...</p>
            )}
            {!carregandoHistorico && historico.length === 0 && (
              <p className="text-muted mb-0">
                Não há registro de atividade de comprovantes para esta venda.
              </p>
            )}
            {!carregandoHistorico && historico.length > 0 && (
              <Timeline lineColor={'#dfe5ed'} animate={true} className="ml-auto">
                {historico.map((h, index) => {
                  const cor = getCorHistoricoComprovante(
                    h.tipo,
                    index === 0,
                    StatusAtual
                  );
                  const historicoKey = [
                    h.tipo,
                    h.data,
                    h.usuario && h.usuario.nome,
                    h.titulo_documento,
                  ].join('-');

                  return (
                    <TimelineItem
                      key={historicoKey}
                      dateText={helpers.format.date(
                        h.data,
                        DATETIME_DEFAULT_FORMAT
                      )}
                      dateInnerStyle={{
                        background: cor,
                      }}
                      style={{
                        color: cor,
                      }}
                    >
                      <>
                        <h5>{h.titulo}</h5>
                        <p className="text-muted">{h.usuario.nome}</p>
                        {h.motivos.length > 0 && (
                          <ul>
                            {h.motivos.map(m => (
                              <li key={`${m.motivo}-${m.justificativa || ''}`}>
                                {m.motivo}
                                {m.justificativa && (
                                  <>
                                    <span>:</span>
                                    <span className="text-muted">
                                      {m.justificativa}
                                    </span>
                                  </>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                        {h.justificativa && (
                          <p>Justificativa: {h.justificativa}</p>
                        )}
                        {h.titulo_documento && (
                          <small>Título documento: {h.titulo_documento}</small>
                        )}
                      </>
                    </TimelineItem>
                  );
                })}
              </Timeline>
            )}
          </section>

          {exibeModalJustificativa && (
            <Modal
              show={exibeModalJustificativa}
              onHide={this.fecharModalJustificativa}
              centered
              backdrop="static"
              dialogClassName="comprovante-justificativa-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title>{tituloModalJustificativa}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p className="text-muted">{descricaoModalJustificativa}</p>
                <label
                  className="comprovante-justificativa-modal__label"
                  htmlFor="justificativaComprovante"
                >
                  Justificativa
                </label>
                <textarea
                  id="justificativaComprovante"
                  value={justificativa}
                  autoFocus
                  className="form-control comprovante-justificativa-modal__textarea"
                  placeholder={placeholderModalJustificativa}
                  onChange={e =>
                    this.setState({
                      justificativa: e.target.value,
                    })
                  }
                ></textarea>
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.fecharModalJustificativa}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className={`btn ${
                    acaoJustificativa === 'pendencia'
                      ? 'btn-warning'
                      : 'btn-success'
                  }`}
                  disabled={desabilitarBotaoAprovar}
                  onClick={this.confirmarModalJustificativa}
                >
                  Confirmar
                </button>
              </Modal.Footer>
            </Modal>
          )}

          {documentoModal && (
            <Modal
              show={documentoModal !== null}
              onHide={() => this.setDocumentoModal(null)}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <small>{documentoModal.descricao}</small>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <a
                  href={documentoModal.url || documentoModal.URL}
                  title="Clique para visualizar o PDF"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {documentoModal.Thumb ? (
                    <img
                      src={documentoModal.Thumb}
                      alt={documentoModal.descricao}
                      className="img-fluid"
                    />
                  ) : (
                    <span>Abrir documento em nova aba</span>
                  )}
                </a>
              </Modal.Body>
            </Modal>
          )}
        </div>
      </>
    );
  }
}

export default AnexarComprovante;
